import { render, staticRenderFns } from "./FallbackDepartureCard.vue?vue&type=template&id=2aba0152"
import script from "./FallbackDepartureCard.vue?vue&type=script&lang=ts"
export * from "./FallbackDepartureCard.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports